import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-exibir-whatsapp',
  templateUrl: './exibir-whatsapp.component.html',
  styleUrls: ['./exibir-whatsapp.component.scss']
})
export class ExibirWhatsappComponent implements OnInit {
  @Input()
  empresa: any;
  @Input()
  light: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  getNumeroZap(){
    if(!this.empresa) return '';

    if(this.empresa.numeroWhatsapp)
      return this.empresa.numeroWhatsapp.whatsapp;

    return this.empresa.whatsapp
  }
}
